<!-- <h3 style="display: inline-block;">Resumen de la categoría</h3> -->
<!-- <h3 style="display: inline-block;">Resumen</h3> -->

<!-- @TODO: descomentar y arreglar -->
<!-- <div class="row">
  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
    <tournaments-number-players
      [drawings]="categoryGroupsDrawings()"
    ></tournaments-number-players>
  </div>
  <div class="col-12 col-sm-6 col-lg-4 col-xxxl-3">
    <tournaments-played-games-ui
      [groupsGames]="categoryGroupsGames()"
      [playedGroupsGames]="categoryPlayedGroupsGames()"
      [drawsNumGames]="categoryDrawsNumGames()"
      [playedDrawsGames]="categoryPlayedDrawsGames()"
    ></tournaments-played-games-ui>
  </div>
</div> -->

<!-- <mat-divider></mat-divider> -->

<!-- @TODO: deprecated -->
<!-- <tournaments-draws-category-ui
  [categoryGroupsDrawings]="categoryGroupsDrawings()"
  [categoryGroupNames]="categoryGroupNames()"
  [categoryGroupsGames]="categoryGroupsGames()"
  [categoryGroupsRankings]="categoryGroupsRankings()"
></tournaments-draws-category-ui> -->
@for (event of rootEvents(); track event.id; let index = $index; let first = $first) {
  <!-- @TODO: ver que hacer con esto -->
  <!-- [subscriptionsState]="(subscriptionsState$ | async)?.value"
    [drawingsState]="(drawingsState$ | async)?.value" -->
  <!-- @TODO: faltan incluir estos 2 -->
  <!-- <div class="row" [ngClass]="{'mt-50': !first}"> -->
  <!-- @TODO -->
  <!-- [class.component-dark-theme]="themeService.isDark()"
    [class.rtl-enabled]="themeService.isRTLEnabled()" -->
  <mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"

  >
    <mat-card-header>
      <mat-card-title>
        @if (event.title1) {
          <h3 class="mb-0">{{ event.title1 }}</h3>
        }
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <h4>Resumen</h4>

      <tournaments-categories-events-overview-ui
        [tournament]="tournament()"
        [eventsIndex]="index"
        [drawings]="drawings()"
        [games]="games()"
      ></tournaments-categories-events-overview-ui>

      @if (categories().length > 1) {
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="end"
          animationDuration="0ms"
          [selectedIndex]="activeTab()"
          (selectedTabChange)="tabChange.emit($event.index)"
        >
          @for (category of categories(); track category.id) {
            <mat-tab [label]="category.name">
              <ng-container *ngTemplateOutlet="tabContent"></ng-container>
            </mat-tab>
          }
        </mat-tab-group>

        <ng-template #tabContent></ng-template>
      }

      <event-ui
        [tournament]="tournament()"
        [event]="event"
        [drawings]="tournamentCategoryDrawings()"
        [games]="tournamentCategoryGames()"
        [groupsRankings]="tournamentGroupsRankings()"
        [eventsRankings]="tournamentEventsRankings()"


      ></event-ui>
    </mat-card-content>
  </mat-card>
}

    <!-- <h3 style="display: inline-block; margin-top: 40px;">Eliminación directa</h3>

    <div style="display: inline-block; width: 100px; margin-left: 15px;">
    <span class="percentage d-block">
      0%
    </span>
      <mat-progress-bar mode="determinate" value="0"></mat-progress-bar>
    </div> -->

<!-- <mat-divider></mat-divider> -->

<!-- <h4 style="margin-top: 30px;">Cuadro A</h4> -->
<!-- @TODO: descomentar y arreglar -->
<!-- <tournaments-brackets-ui
  [categoryNumGroups]="categoryGroupNames().length"
  [categoryDrawsNumGames]="categoryDrawsNumGames()"
  [categoryDrawings]="categoryDrawings()"
  [categoryGames]="categoryGames()"
></tournaments-brackets-ui> -->

<!-- @if (['11', '12'].includes(tournament().strId)) {
  <h5 style="margin-top: 30px;">Cuadro B</h5>
  @if (tournament().strId === '11') {
    <tournaments-brackets-tmp-ui></tournaments-brackets-tmp-ui>
  } @else if (tournament().strId === '12') {
    <tournaments-brackets-tmp2-ui></tournaments-brackets-tmp2-ui>
  }
} -->
